module.exports = "https://cdn.thelire.com/ins/resource/lh_feed_special.a8285ebeb636341fee44f618f9934b38.png";